<template>
  <div style="background-color: white;">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
      <HistoriaClinicaV2 :idPacienteProp="idPaciente" :idClinicaProp="idClinica" ref="historia" :edicionLinkUsuario="true"/>
  </div>
</template>
<script>
import HistoriaClinicaV2 from "@/views/perfilPacientes/historialClinica/HistoriaClinicaV2";

export default {
  components: {
    HistoriaClinicaV2,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    idPaciente: null,
    idClinica: null
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    let parametros = this.$route.params.idPaciente.split('/*')
    this.idPaciente = Number(this.$global.desencriptar(parametros[0]).replace(/"/g, ''));
    this.idClinica = Number(this.$global.desencriptar(parametros[1]).replace(/"/g, ''));
  },
  methods: {

  }
};
</script>
